import { render, staticRenderFns } from "./scrollMore.vue?vue&type=template&id=0e57ae1a&"
import script from "./scrollMore.vue?vue&type=script&lang=js&"
export * from "./scrollMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports